import * as _ from 'lodash-es'

import { CHECKBOX_FILTERS, CHECKBOX_FILTERS_WITH_DATES } from '../constants'

/**
 * Reusable function to configure URL parameters based on search term and filters.
 * @param {string} specifiedSearchTerm - The search term to be used in the query.
 * @param {Object} filters - The selected filters for the query.
 * @param {Object} [dateFilters] - Optional map of backend date-range params (e.g.
 *   `resolved_at__gte: '2026-05-01'`). Empty strings are skipped.
 */
export const configureUrlParams = (specifiedSearchTerm, filters, dateFilters = null) => {
  let params = ''
  const filterQuery = configureFilterQuery(filters, null, dateFilters)

  if (specifiedSearchTerm) {
    params = `q=${specifiedSearchTerm}`
  }
  if (filterQuery !== '' && filterQuery !== '&') {
    params = `${params === '' ? '' : `${params}&`}${filterQuery}`
  }

  return params === '' ? '' : params
}

/**
 * Configures the filter query, without the specified `without` value.
 * @param {string} without
 */
const configureFilterQuery = (filters, without = null, dateFilters = null) => {
  const filterQuery = { ...filters }

  filterQuery.line_items__technician = filterQuery.technician
  filterQuery.line_items__actions_needed__action = filterQuery.actionNeeded
  delete filterQuery.actionNeeded
  delete filterQuery.technician

  if (without) delete filterQuery[without]

  const parts = _.map(filterQuery, (value, key) => {
    if (!value || value.length === 0) return null
    if (CHECKBOX_FILTERS.includes(key)) return CHECKBOX_FILTERS_WITH_DATES[key]
    return `${key}=${_.map(value, 'id').join(`&${key}=`)}`
  }).filter((x) => x !== null)

  if (dateFilters) {
    Object.entries(dateFilters).forEach(([param, value]) => {
      if (value) parts.push(`${param}=${value}`)
    })
  }

  return parts.join('&')
}
